import { CountUp } from 'countup.js';

$(function () {

  $('.preloader').on({

    relatedTarget: $.each($('.js-countup'), function () {

      var count = $(this).data('to');
      var settings = {
        startVal: $(this).data('from'),
        decimalPlaces: $(this).data('decimals'),
        duration: 2,
        useGrouping: $(this).data('grouping'),
        separator: $(this).data('separator'),
        decimal: $(this).data('decimal'),
      }

      let numAnim = new CountUp(this, count, settings);

      numAnim.start();

    })
  })


  $(".preloader").delay(2500).fadeOut("slow", function () {
    $('body').removeClass('loading');
  });

  (<any>$('[data-fancybox="images"]')).fancybox({
    infobar: false,
    buttons: [
      "close"],
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button btn-close" title="{{CLOSE}}">' +
        "</button>",
      // Arrows
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button btn-prev" title="{{PREV}}">' +
        "</button>",

      arrowRight:
        '<button data-fancybox-next class="fancybox-button btn-next" title="{{NEXT}}">' +
        "</button>",
    },

  });



  // ##############################################
  // ################# Nav ########################
  // ##############################################


window.onscroll = function() {scrollFunction()};

function scrollFunction() {

  if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
  
    $(' nav .navbar .main-nav .nav-item').removeClass('normal');
    $(' .navbar-brand').removeClass('normal');
    $(' nav .navbar .main-nav .nav-item').addClass('small');
    $(' .navbar-brand').addClass('small');
    
  } else {
  
    $(' nav .navbar .main-nav .nav-item').removeClass('small');
    $(' .navbar-brand').removeClass('small');
    $(' nav .navbar .main-nav .nav-item').addClass('normal');
    $(' .navbar-brand').addClass('normal');
  
  }

} 

  var subNavImg = $('.dropdown-menu .sub-nav-image');
  var mainNav = $('.main-nav > .nav-item');

  $(mainNav).on('click',function(){
  
    $(this).addClass('active');
    $(this).siblings('.nav-item').removeClass('active');
    
  })

   $(subNavImg).on('click touch',function(){
   
   $(this).children().addClass('active');
   $(this).siblings().children().removeClass('active');
   $(this).parents('.nav-item').children('.nav-link').addClass('active');

  })

  $('.dropdown-menu .sub-nav-item').on('click touch',function(){
   
  
    $(this).children().addClass('active');
    $(this).siblings().children().removeClass('active');
    $(this).parents('.nav-item').addClass('active');
   console.log($(this).parents());
    if(subNavImg.children().hasClass('active')){
     subNavImg.children().removeClass('active');
    }
  
   
   })



  // ##############################################
  // ################# Mobile sub-nav #############
  // ##############################################
  
  var flag = 0;
  $('.mobile-nav .nav-link').on('click', function () {
    
    $(this).parent().addClass('active');
    
    if(flag === 0){
      flag = 1;
    }else{
      flag= 0;
    }
    

    if($(this).parent().hasClass('active')){
      $(this).children('i').removeClass('fal fa-chevron-down');
      $(this).children('i').addClass('fal fa-chevron-up');
      
    }

 
    if($(this).parent().siblings().hasClass('active')){
      
      $(this).parent().siblings().removeClass('active');
      $(this).parent().siblings().children('a').removeClass('active');
      $(this).parent().siblings().children().children('i').removeClass('.fal fa-chevron-up');
      $(this).parent().siblings().children().children('i').addClass('.fal fa-chevron-down');
      var lastActiveLink = $(this).parent().siblings().children().find('a');
      lastActiveLink.removeClass('active');
      
      flag = 1;
    }

    if(flag === 0){
      $(this).children('i').removeClass('fal fa-chevron-up');
      $(this).children('i').addClass('fal fa-chevron-down');
    }


  });

  $('.mobile-nav .navbar-nav li').on('click',function(){
     
      $(this).children('.sub-nav-link').addClass('active');
      $(this).siblings().children().removeClass('active');
     
      var activeDropdownIcon = $(this).parentsUntil('#ham-menu').children().children().children('i');
      
      if($(this).children('.sub-nav-link').hasClass('active')){
        
      activeDropdownIcon.removeClass('fal fa-chevron-up');
      activeDropdownIcon.addClass('fal fa-chevron-down');

      }
      
    
  })

  // ##############################################
  // #### historie image animation in viewport ####
  // ##############################################
  var $animation_elements = $('.story-telling img');
  var $window = $(window);

  function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = ((window_top_position as number) + (window_height as number));

    $.each($animation_elements, function () {
      var $element = $(this) as any;
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = (element_top_position + (element_height as number));

      //check to see if this current container is within viewport
      if ((element_bottom_position >= (window_top_position as number)) &&
        (element_top_position <= window_bottom_position)) {
        $element.addClass('animation-start');
      } else {
        $element.removeClass('animation-start');
      }
    });
  }

  $window.on('scroll resize', check_if_in_view);
  $window.trigger('scroll');


  // ##############################################
  // ################# Accordion ##################
  // ##############################################

  var $navOffset = $('nav .navbar').outerHeight();
  
  $('.accordion .collapse').on('shown.bs.collapse', function (e) {
    
    var otherAcc = $('.accordion .collapse');
    var clickedAcc = $(e.target);
    
    for (let i = 0; i < otherAcc.length; i++) {

      if (otherAcc.hasClass('show')) {
        otherAcc.removeClass('show');
        clickedAcc.addClass('show')

        otherAcc.siblings().find('button').addClass('collapsed');
        clickedAcc.siblings().find('button').removeClass('collapsed');

      } else {
        clickedAcc.addClass('show');
      }
    }

    //scroll active accordion to top
    var id = $(e.target).parent().find("[id]")[0].id;
    var cardHeader = $("#" + id);
    var parentItem = cardHeader.closest('.card');

    var win = $(window);
    var viewport = {
      top: win.scrollTop(),
    };
    var bounds = parentItem.offset() as any;
    var itemHeight = parentItem.outerHeight();
    if ((itemHeight as number) > (win.height() as number) || ((viewport.top as number) + ((win.height() as number) / 2)) < (bounds.top) || bounds.top < ((viewport.top as number) + ($navOffset as number))) {
      $('html, body').animate({
        scrollTop: ($(parentItem).offset()!.top - ($navOffset as number))
      }, 800);
    }


  });


  // ##############################################
  // #################### forms ###################
  // ##############################################  

  $('input, textarea').each(function () {
    if ($(this).val() != "") {
      $(this).addClass("has-content");
    } else {
      $(this).removeClass("has-content");
    }
  });

  $('input, textarea').on('focusin', function () {
    $(this).addClass("focus");
  });

  $('input, textarea').on('focusout', function () {
    $(this).removeClass("focus");
    if ($(this).val() != "") {
      $(this).addClass("has-content");
    } else {
      $(this).removeClass("has-content");
    }
  });

 

  //floating-selectpicker ///////////////////////
  var showSelect = $('select ~ button').find('.filter-option-inner-inner');

  $(window).on('load',function(){
    
    $('select ~ button').find('.filter-option-inner-inner').empty();

  })
  
 
    $(document).ready(function () {
 
      $('.form-group').find('.filter-option-inner-inner').empty();
      $('.selectpicker-float button').attr('title','');
      $('form').find('select').val("");
      $('form').find('select').prepend('<option value="Anrede" class="d-none"></option>');
      $('select ~ button').find('.filter-option-inner-inner').empty();
     
    });
  
  $('.bootstrap-select').on('click',function(){
  
    let label = $(this).siblings('.selectpicker-label');
    let id = $(this).children().get(0).id;
    // let showSelect = $(this).find('.filter-option-inner-inner');
  
    $('ul').children('li').on('click',function(){
      let select = $(this).text();
      showSelect.text(select);
     
      selectCheck();
      
    });

  })
  
  $('.selectpicker-float').on('click',function(){
    
    if($('.filter-option-inner-inner').text() == ''){
      $('.selectpicker-label').css('font-size','100%');
      $('.selectpicker-label').css('top','12.8px');
    } 
    else{
      $('.selectpicker-label').css('font-size','75%');
      $('.selectpicker-label').css('top','-5px');
    }
    
  })

function selectCheck(){
  if($('.filter-option-inner-inner').text() == ''){
    $('.selectpicker-label').css('font-size','100%');
    $('.selectpicker-label').css('top','12.8px');
  } 
  else{
    $('.selectpicker-label').css('font-size','75%');
    $('.selectpicker-label').css('top','-5px');
  }
}


let uploadBtn = $('input[type="file"]');

uploadBtn.on('change', function(){

  let id = '#' + this.id;
  let fileChosen = $(id).parent().siblings('.chosen-file').children();
  
  fileChosen.html('<i class="fal fa-file-pdf"></i>' + ' ' + this.files[0].name);
  fileChosen.append('<a class="remove-file"></a>');
 
  fileChosen.on('click',function(){
    $(id).val('');
    fileChosen.empty();
  });
})



  // ##############################################
  // ############ machine-data counter ###########
  // ############################################# 

  function machineInfosInViewport(el: any) {
    var el = el.get(0);
     var $navOffset = $('nav .navbar').outerHeight();
    var top = el.offsetTop;
    var height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
    }
    return (
      (top + height) >= (window.pageYOffset + ($navOffset as number)) &&
      (top + 5) < (window.pageYOffset + window.innerHeight)
    );

  }

  function machineInfoCount(el: any) {
    var counters = $(el).find(".js-countup");
    $.each(counters, function () {
      var count = $(this).data('to');
      var settings = {
        startVal: $(this).data('from'),
        decimalPlaces: $(this).data('decimals'),
        duration: 2,
        useGrouping: $(this).data('grouping'),
        separator: $(this).data('separator'),
        decimal: $(this).data('decimal'),
      }
      let countAnim = new CountUp(this, count, settings);
      countAnim.start();
    });
  }
  function machineInfoReset(el: any) {
    var counters = $(el).find(".js-countup");
    $.each(counters, function () {
      var start = $(this).data('from');
      $(this).html(start);
    });
  }

  function machineInfosCheck() {
    $('.machine-infos').each(function () {
      var countContainer = $(this).find('.machine-container');
      if (machineInfosInViewport(countContainer)) {
        if (!countContainer.hasClass('counted')) {
          machineInfoCount(countContainer);
          countContainer.addClass('counted');
        }
      } else {
        machineInfoReset(countContainer);
        countContainer.removeClass('counted');
      }
    });
  }


  if ($('.machine-infos').length) {

    machineInfosCheck();
    
    $(window).scroll(function () {
      machineInfosCheck();
    });
    $(window).resize(function () {
      machineInfosCheck();
    });

  }


  // ##############################################
  // #################### Footer Nav ##############
  // ##############################################
  // var subNavImg = $('.dropdown-menu .sub-nav-image');
  // var mainNav = $('.main-nav > .nav-item');
 

$('footer .nav-item').on('click',function(){
  $(this).addClass('active');
  $(this).siblings().removeClass('active');

})

});
